<template>
    <core-section id="about">

        <core-heading>{{ $t('about.title') }}</core-heading>

        <v-col cols="12" md="7">
            <v-row justify="space-between">
                <v-col cols="12" md="7">
                    <core-text class="mb-0">
                        <p v-text="$t('about.description')" />
                    </core-text>
                </v-col>

                <v-col cols="12" md="4">
                    <v-row align="center">
                        <v-col cols="6" class="text-uppercase primary--text font-weight-medium">
                            <p class="mb-3">
                                <v-icon size="20" color="primary" class="mr-1"> mdi-phone </v-icon
                                >{{ $t('general.phone-txt') }}
                            </p>

                            <p class="mb-3">
                                <v-icon size="20" color="primary" class="mr-1"> mdi-email </v-icon
                                >{{ $t('general.email-txt') }}
                            </p>

                            <p class="mb-3">
                                <v-icon size="20" color="primary" class="mr-1">
                                    mdi-map-marker </v-icon
                                >{{ $t('general.location-txt') }}
                            </p>
                        </v-col>
                        <v-col cols="6" class="subheading text-no-wrap">
                            <div class="mb-3 link">
                                <a :href="'tel:' + $t('general.phone-call')">{{
                                    $t('general.phone-web')
                                }}</a>
                            </div>

                            <div class="mb-3 link">
                                <a :href="'mailto:' + $t('general.email')">{{
                                    $t('general.email')
                                }}</a>
                            </div>

                            <div class="mb-3" v-text="$t('general.location')" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>

        <v-col class="hidden-sm-and-down text-right text-uppercase" cols="5">
            <div class="text-h4" v-text="$t('general.name')" />

            <span class="primary--text text-h5 font-weight-light" v-text="$t('general.label')" />

            <v-img
                :src="require('@/assets/logos/logo.svg')"
                contain
                height="auto"
                width="600"
                style="right: 0; position: absolute; top: 300px;"
            />
        </v-col>
    </core-section>
</template>

<script>
export default {
    name: 'About',

    components: {
        Abstract1: () => import('@/components/Abstract1'),
    },
};
</script>

<style lang="scss" scoped>
.v-expansion-panels > li {
    border-top: 1px solid rgba(#fff, 0.12) !important;
}
.link a {
    text-decoration: none;
    color: white;
}

.link a:hover {
    text-decoration: none;
    color: #ffaa00;
}
</style>
